/**
 * V2 i18n — additive layer on top of the shared V1 i18next instance.
 *
 * V1 owns the i18next init + LanguageDetector (see src/i18n/index.ts). Here we
 * only ADD a separate 'v2' namespace so V2 copy lives in its own bundle and
 * never collides with the V1 'translation' namespace. Importing this module is
 * a side-effect: it registers the English 'v2' bundle on the shared instance.
 *
 * Components opt in with useTranslation('v2'). Other languages fall back to
 * English until their v2 bundles are added.
 */
import i18n from '@/i18n';

// Auto-load EVERY locale bundle in ./locales (en.json + the GPT-generated
// translations) and register each under the 'v2' NAMESPACE on the shared
// instance — so adding a language is just dropping its <code>.json in the folder.
// (deep = true, overwrite = true) so re-registering during HMR refreshes keys.
const bundles = import.meta.glob('./locales/*.json', { eager: true }) as Record<
  string,
  { default: Record<string, unknown> }
>;
for (const [path, mod] of Object.entries(bundles)) {
  const code = path.split('/').pop()!.replace('.json', '');
  i18n.addResourceBundle(code, 'v2', mod.default, true, true);
}

// NOTE: V2 intentionally keeps the layout LEFT-TO-RIGHT for every language,
// including Arabic/Hebrew — we translate the text only, not the layout. Flipping
// document.dir to 'rtl' mirrored the whole UI and broke it, so the RTL handling
// was removed on purpose. Re-introduce it (and the logical ms-/ps-/text-start
// Tailwind classes) only if a real RTL layout is later desired.

export default i18n;
